import { useMemo } from "react";
/**
 * Custom hook to fetch and sort global-icons actions from extensions.
 * These are actions registered by extensions to appear in global UI areas.
 * Filters out actions marked with classicOnly: true since the Modern UI
 * has its own built-in alternatives.
 *
 * @param extensions - The extension manager instance
 * @returns Sorted array of global-icons action definitions (excluding classicOnly actions)
 */
export const useGlobalIconActions = (extensions) => {
    return useMemo(() => {
        const actions = [];
        extensions.apply("registerAction", (_extInfo, group, position, iconOrComponent, options, title, action) => {
            if (group === "global-icons" &&
                typeof iconOrComponent === "string" &&
                !options?.isClassicOnly) {
                actions.push({
                    icon: iconOrComponent,
                    title,
                    position,
                    action,
                    options,
                });
            }
        }, true);
        return actions.sort((a, b) => (a.position ?? 100) - (b.position ?? 100));
    }, [extensions]);
};
